<mat-dialog-content>
  <h1 mat-dialog-title [innerHTML]="'form.annual.declaration.section1.area6.title' | translate "></h1>

  <div class="d-flex flex-column mt-2"
    [formGroup]="myGroup">
    <div class="d-flex flex-row align-items-center mt-2">
      <div class="flex-fill"
      [innerHTML]="'form.annual.declaration.section1.area6.number_1' | translate"></div>
      <odq-text-input badge="A" formControlName="numberVotingODQ" helpTopicBadge></odq-text-input>
    </div>
    <div class="d-flex flex-row align-items-center mt-2">
      <div class="flex-fill"
      [innerHTML]="'form.annual.declaration.section1.area6.number_2' | translate"></div>
      <span class='fa fa-plus text-danger font-weight-bold p-2'></span>
      <odq-text-input badge="B" formControlName="numberVotingOther" helpTopicBadge></odq-text-input>
    </div>
    <div class="d-flex flex-row align-items-center mt-2">
      <div class="flex-fill"
      [innerHTML]="'form.annual.declaration.section1.area6.number_3' | translate"></div>
      <span class='text-danger font-weight-bold p-2'>=</span>
      <odq-text-input badge="C" formControlName="numberVotingTotal" helpTopicBadge></odq-text-input>
    </div>
    <!-- Error Messages -->
    @if (hasTrusteesErrors) {
      <div class="d-flex align-items-center justify-content-between flex-fill alert alert-danger"
        >
        <div>{{'form.annual.declaration.section3.summaryDialog.countOfTrusteesError' | translate}}</div>
        <mat-icon>
          error_outline
        </mat-icon>
      </div>
    }
    @if (hasVotingPartsCountErrors) {
      <div class="d-flex align-items-center justify-content-between flex-fill alert alert-danger"
        >
        <div [innerHTML]="'form.annual.declaration.section3.summaryDialog.votingPartsCountError' | translate"></div>
        <mat-icon>
          error_outline
        </mat-icon>
      </div>
    }
    <!-- Success messages -->
    @if (!hasVotingPartsCountErrors) {
      <div class="d-flex align-items-center justify-content-between flex-fill alert alert-success"
        >
        <div [innerHTML]="'form.annual.declaration.section3.summaryDialog.votingPartsCountSucces' | translate"></div>
        <mat-icon>
          check_circle_outline
        </mat-icon>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  @if ((hasTrusteesErrors || hasVotingPartsCountErrors) ) {
    <button mat-flat-button
      (click)="fixErrors()"
      color="primary">
      {{'form.annual.declaration.section3.summaryDialog.adjust' | translate}}
    </button>
  } @else {
    <button mat-flat-button
      color="primary"
      (click)="nextStep()">
      {{'form.annual.declaration.section3.summaryDialog.nextStep' | translate}}
    </button>
  }
</mat-dialog-actions>